import { CONV_STORAGE, lockFocus, muteAll, onStage, Video } from "../libs/roomnew";

export default class BottomActions{
    constructor(){
        this.actions={};
        //add buttons container
        this.actionButtonsContainer=$("<div/>",{
            class:'my-convo-buttons',
            id:'split-unlock-button-cont',
            html: []
        });
        this.bannerExplanationText=$('<div/>',{
            class:'my-convo-name'
        });
        this.bannerIcon=$('<div/>',{
            class:'conv-image image-1',
            html:lockFocus.lockFocusIconNotification
        });
        let iconContainer=$('<div/>',{
            html:this.bannerIcon,
            class:'my-convo-participants my-convo-participants-lock-focus'
        });
        let bannerContent=$("<div/>",{
            html:[iconContainer,this.bannerExplanationText,this.actionButtonsContainer],
            class:"my-convo-content custom",
        })
        this.bottomActionsContainer=$('<div/>',{
            class:"my-convo-top-banner position-top",
            html: [bannerContent]
        }).on('mouseover',()=>{
            this.bottomActionsContainer.addClass('mouseover');
        }).on('mouseleave',()=>{
            this.bottomActionsContainer.removeClass('mouseover');
        });
        this.spaceActionButtonsContainer=$('#my-conversation-banner .my-convo-buttons');
        // if(CONV_STORAGE.myConversation) {
        //     this.unlockFocusBtn.sty
        //     this.unlockBanner.removeClass('shownAnimated').css('display','none');
        //     this.unlockFocusBtn.appendTo($('#my-conversation-banner .my-convo-buttons'));
        // }
        Video.videoSpace.append(this.bottomActionsContainer);
        this.idsByContainer={};
        this.shown=false;
        this.hideBannerTimeout=0;
    };

    startHideBannerTimeout(seconds=3){
        clearTimeout(this.hideBannerTimeout);
        this.hideBannerTimeout=setTimeout(() => {
            if(!this.bottomActionsContainer.hasClass('mouseover')){
                this.hideBottomActtions();
            }
        }, 1000 * seconds);
    };

    showBottomAction(){
        if(!CONV_STORAGE.myConversation){
           this.bottomActionsContainer.removeClass('hiddenImportant hiddenAnimated').addClass('shownAnimated');
           this.shown=true;
           $("#videoSpace").addClass("actions-shown");
        }else{
            if(this.bottomActionsContainer.hasClass("shownAnimated")){
                this.hideBottomActtions();
            }
        }
    };

    hideBottomActtions(){
        $("#videoSpace").removeClass("actions-shown");
        this.bottomActionsContainer.removeClass('shownAnimated').addClass('hiddenAnimated');
        this.shown=false;
    };

    addAction(id,button,onClick=false,showInSpace=false,position="after",message=""){
        if(!this.actions[id]){
            this.actions[id]=button;
            if(position=="after"){
                if( CONV_STORAGE.myConversation && CONV_STORAGE.bannerShown && showInSpace){
                    this.spaceActionButtonsContainer.append(this.actions[id]);
                    this.idsByContainer[id]="spaces";
                }else{
                    this.actionButtonsContainer.append(this.actions[id]);
                    this.idsByContainer[id]="lobby";
                }
            }else{
                if( CONV_STORAGE.myConversation && CONV_STORAGE.bannerShown  && showInSpace){
                    this.spaceActionButtonsContainer.prepend(this.actions[id])
                    this.idsByContainer[id]="spaces";
                }else{
                    this.actionButtonsContainer.prepend(this.actions[id]);
                    this.idsByContainer[id]="lobby";
                }
            }
            if(onClick){
               this.actions[id].on('click',onClick);
            }
        }
        this.onActionAdded(id,message);
        if(!this.shown){
            this.addHideButton();
            this.showBottomAction();
        }
    };

    addHideButton(){
        //<button class="btn btn-sm btn-outline-white btn-rounded ml-2" id="release-pull-focus">Off Stage</button>
        this.hideButton=$("<button/>",{
            class:'btn-blur btn-blur-sm ml-2 text-white/95 mb-0 text-uppercase btn-transaparent',
            id:"hide-actions-btn",
            style:'min-width:60px;width:60px',
            html:'Hide'
        }).on('click',()=>{
            this.hideBottomActtions();
            this.bottomActionsContainer.addClass('hiddenImportant');
            CONV_STORAGE.showBannerInfo();
        });
        this.actionButtonsContainer.append(this.hideButton);
    };

    deleteHideButton(){
        if(this.hideButton){
            this.hideButton.remove();
            this.hideButton=undefined;
        }
        this.actionButtonsContainer.find('#hide-actions-btn').remove();
    };

    moveToSpacesActions(id,position="after"){
        try {
           if(position=="after"){
                this.actions[id].appendTo(this.spaceActionButtonsContainer);
            }else{
                this.actions[id].prependTo(this.spaceActionButtonsContainer);
            }
            this.idsByContainer[id]="spaces";
            if(this.shown && Object.values(this.idsByContainer).filter(cont=>cont=="lobby").length == 0 ){
                this.hideBottomActtions();
            }
        } catch (error) {

        }


    }
    moveToBottomActions(id,position="after"){
        try {
             if(position=="after"){
                this.actions[id].appendTo(this.actionButtonsContainer);
            }else{
                this.actions[id].prependTo(this.actionButtonsContainer);
            }
            this.idsByContainer[id]="lobby";
            if(Object.values(this.idsByContainer).filter(cont=>cont=="lobby").length > 0 ){
                this.showBottomAction();
            }
        } catch (error) {
                console.error("Error moving to bottom action",error)
        }

    }
    removeAction(id){
        if(this.actions[id]){
            this.actions[id].remove();
            delete this.actions[id];
            delete this.idsByContainer[id];
        }
        if(id && onStage.isActive()){
            return
        }
        if(Object.keys(this.actions).length==0){
            this.hideBottomActtions();
            this.deleteHideButton();
            CONV_STORAGE.hideBannerInfo();
        }
        this.onActionRemoved(id);
    };

    actionShown(id){
        return this.actions[id] !== undefined;
    }

    onActionAdded(id, message=""){

        if(id=="lock-focus"){
            this.bannerIcon.html(lockFocus.lockFocusIconNotification);
            if(!this.actions['release-focus']){
                this.bannerExplanationText.html("Focus is locked");
            }
        }else if(id=="release-focus"){
            this.bannerExplanationText.html(message);
            // if(!this.actions['lock-focus']){
                this.bannerIcon.html(lockFocus.focusedIcon);
            // }else{
                // this.bannerIcon.html(lockFocus.lockFocusIconNotification);
            // }
        }else if(id="mute-all"){
            this.bannerIcon.html(muteAll.muteIcon);
            this.bannerExplanationText.html(message);
        }
    }

    onActionRemoved(id){
        if(id=="lock-focus"){
            this.bannerIcon.html(lockFocus.focusedIcon);
            if(!this.actions['release-focus']){
                this.bannerExplanationText.html("Focus is locked");
            }
        }else if(id=="release-focus"){
            if(!this.actions['lock-focus']){
                this.bannerExplanationText.html("");
                this.bannerIcon.html(lockFocus.focusedIcon);
            }else{
                this.bannerIcon.html(lockFocus.lockFocusIconNotification);
                this.bannerExplanationText.html("Focus is locked");
            }
        }
    };

    spacesBannerStateChanged(){
        if(Object.keys(this.actions).length==0){
            this.shown && this.hideBottomActtions();
            return;
        }
        if(CONV_STORAGE.myConversation && CONV_STORAGE.bannerShown){
            if(this.shown){this.hideBottomActtions()}
        }else{
            if(!this.shown){this.showBottomAction()}
        }
    }

};
